import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Link } from 'react-router-dom'
import { AnimatedSwitch, spring } from 'react-router-transition'
import IdleTimer from 'react-idle-timer'

import Home from './components/pages/Home'
import BauenImBestand from './components/pages/baunimbestand/BauenImBestand'
import BauenImBestandReferenzen from './components/pages/baunimbestand/Referenzen'
import BauenImBestandLeistungen from './components/pages/baunimbestand/Leistungen'
import Bauservice from './components/pages/bauservice/Bauservice'
import BauserviceReferenzen from './components/pages/bauservice/Referenzen'
import BauserviceLeistungen from './components/pages/bauservice/Leistungen'
import BauserviceLeistungenVerputzerteam from './components/pages/bauservice/LeistungenVerputzerteam'
// import SideMenuContent from "./components/sidemenu/SideMenuContent"
import ImageVideo from './components/pages/ImageVideo'
import Provider, { Context } from './components/Context'
import BackIcon from './assets/icons/back.svg'
import InfoIcon from './assets/icons/info.svg'
import InfoIconActive from './assets/icons/info-active.svg'
import './components/sidemenu/sidemenu.css'
import SideMenuInfo from './components/sidemenu/SideMenuInfo'
import Animation from './components/pages/Animation'
import ReferencesDetail from './components/pages/ReferencesDetail'
import ServicesOverview from './components/pages/ServicesOverview'
import ScreenSaver from './components/ScreenSaver'

// we need to map the `scale` prop we define below
// to the transform style property
function mapStyles(styles) {
    return {
        opacity: styles.opacity,
        transform: `scale(${styles.scale})`,
    }
}

// wrap the `spring` helper to use a bouncy config
function bounce(val, damping = 50) {
    return spring(val, {
        stiffness: 330,
        damping: damping,
    })
}

const bounceTransition = {
    // start in a transparent, upscaled state
    atEnter: {
        opacity: 0,
        scale: 15,
    },
    // leave in a transparent, downscaled state
    atLeave: {
        opacity: bounce(0.8),
        scale: bounce(0),
    },
    // and rest at an opaque, normally-scaled state
    atActive: {
        opacity: bounce(1),
        scale: bounce(1),
    },
}

class App extends Component {
    constructor(props) {
        super(props)
        this.state = {
            screenSaverEnabled: false,
        }
    }

    openMenu = context => {
        context.updateState({ sideMenu: !context.state.sideMenu })
    }

    render() {
        const sideMenuOpenClass = context => {
            return context.state.sideMenu ? '' : 'open'
        }
        const sideInfoOpenClass = context => {
            return context.state.infoMenu ? '' : 'open'
        }
        return (
            <Router>
                <Provider>
                    <IdleTimer element={document} onActive={this._onActive.bind(this)} onIdle={this._onIdle.bind(this)} timeout={180000} />
                    <ScreenSaver enabled={this.state.screenSaverEnabled} />
                    <Context.Consumer>
                        {context => (
                            <div style={{ flex: 1, display: 'flex', zIndex: 10 }}>
                                <div className="left-sidebar">
                                    <div className="menu-logo-outer">
                                        <Link to="/">
                                            <div className="menu-button">
                                                <div className={context.props.location.pathname === '/' ? ' menu-logo-active' : 'menu-logo'} />
                                            </div>
                                        </Link>
                                    </div>
                                    {context.state.activeReferenceItem &&
                                        (context.state.infoMenu ? (
                                            <div onClick={() => context.updateState({ infoMenu: false })} style={{ borderRight: '3px solid #DC002E' }} className="info-button">
                                                <img src={InfoIconActive} />
                                            </div>
                                        ) : (
                                            <div onClick={() => context.updateState({ infoMenu: true })} className="info-button">
                                                <img src={InfoIcon} />
                                            </div>
                                        ))}
                                    {context.state.historyBack ? (
                                        <div style={{ flex: 1, display: 'flex', alignItems: 'flex-end' }}>
                                            <div
                                                className="back-button"
                                                onClick={() => {
                                                    context.props.history.push(context.state.historyBack)
                                                }}
                                            >
                                                <img src={BackIcon} />
                                            </div>
                                        </div>
                                    ) : null}
                                </div>
                                <SideMenuInfo className={'left-sidebar-menu-info ' + sideInfoOpenClass(context)} />
                                <AnimatedSwitch
                                    atEnter={bounceTransition.atEnter}
                                    atLeave={bounceTransition.atLeave}
                                    atActive={bounceTransition.atActive}
                                    mapStyles={mapStyles}
                                    runOnMount={true}
                                    className="switch-wrapper"
                                >
                                    <Route exact path="/" component={Home} />
                                    <Route exact path="/bauen-im-bestand" component={BauenImBestand} />
                                    <Route exact path="/bauen-im-bestand/referenzen" component={BauenImBestandReferenzen} />
                                    <Route exact path="/bauen-im-bestand/leistungen" component={BauenImBestandLeistungen} />
                                    <Route exact path="/bauservice" component={Bauservice} />
                                    <Route exact path="/bauservice/referenzen" component={BauserviceReferenzen} />
                                    <Route exact path="/bauservice/leistungen" component={BauserviceLeistungen} />
                                    <Route exact path="/bauservice/leistungen/verputzerteam" component={BauserviceLeistungenVerputzerteam} />
                                    <Route exact path="/imagefilm" component={ImageVideo} />
                                    <Route exact path="/animation" component={Animation} />
                                    <Route exact path="/:type/referenzen/:id" component={ReferencesDetail} />
                                    <Route exact path="/leistungsubersicht" component={ServicesOverview} />
                                </AnimatedSwitch>
                            </div>
                        )}
                    </Context.Consumer>
                </Provider>
            </Router>
        )
    }
    _onActive(e) {
        this.setState({ screenSaverEnabled: false })
    }
    _onIdle(e) {
        this.setState({ screenSaverEnabled: true })
    }
}

export default App
